import { Directive, HostBinding, Input } from "@angular/core";
import { BooleanAttribute } from "@hex/angular/decorators";

@Directive({
    selector: `[modCenterAlignText]`,
})
export class TextModifierDirective {
    @Input() @BooleanAttribute() @HostBinding("class.u-text-align-center") public modCenterAlignText;
}
